<template>
	<div class="view-wrapper">
		<div class="row">
			<div class="col-xl-7">

				<b-card header-tag="h5" header="Ability Scores" class="mb-3" body-class="p-0">
					<basics-ability-scores />
				</b-card>

				<b-card header-tag="h5" header="Biographical Info" class="mb-3" body-class="p-0">
					<basics-biography-info />
				</b-card>
			</div>

			<div class="col-xl-5">
				<b-card header-tag="h5" header="Miscelaneous Modifiers" class="mb-3" body-class="p-0">
					<basics-misc-info />
				</b-card>

				<b-card header-tag="h5" header="Race" body-class="p-0">
					<basics-race-info />
				</b-card>
				
			</div>
		</div>
	</div>
</template>

<script>
import BasicsAbilityScores from '@/components/basics/BasicAbilityScores.vue'
import BasicsBiographyInfo from '@/components/basics/BasicBiographyInfo.vue'
import BasicsMiscInfo from '@/components/basics/BasicMiscInfo.vue'
import BasicsRaceInfo from '@/components/basics/BasicRaceInfo.vue'

export default {
	components: {
		BasicsAbilityScores,
		BasicsBiographyInfo,
		BasicsMiscInfo,
		BasicsRaceInfo,
	}
}
</script>

<style scoped>

</style>